import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Landmark, Users, Heart, BookOpen, Globe, MessageCircle, Star, CheckCircle, Sparkles, Award, Camera, GraduationCap, Handshake, Crown, Building2 } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { LanguageProvider } from '../context/LanguageContext';
export function PoliticiansPage() {
  return <LanguageProvider data-id="element-6514" data-mp="1f1mhmhumu5ke">
      <div className="relative bg-black text-white overflow-x-hidden" data-id="element-6515" data-mp="1eztaz2k0rlce">
        <ScrollProgress data-id="element-6516" data-mp="1a1i2av5gngvr" />
        <Navbar data-id="element-6517" data-mp="1a3b9qcnwe54t" />
        <main className="w-full" data-id="element-6518" data-mp="1a2t3cn7iuaj6">
          <ConstituencyHero data-id="element-6519" data-mp="3gshivp7lywyi" />
          <WhyItMattersSection data-id="element-6520" data-mp="3gro9egh9ltco" />
          <TheExperienceSection data-id="element-6521" data-mp="3gspvdfztk096" />
          <InvolvementOptionsSection data-id="element-6522" data-mp="3bted22jt0mph" />
          <ConstituencyNightSection data-id="element-6523" data-mp="3bufy8zujapkx" />
          <ConstituencyCTA data-id="element-6524" data-mp="3bvhcteardu7e" />
        </main>
        <Footer data-id="element-6525" data-mp="28vp76x7yfnqb" />
      </div>
    </LanguageProvider>;
}
function ConstituencyHero() {
  return <section className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-6526" data-mp="2dth6wdeuce52">
      <div className="absolute inset-0" data-id="element-6527" data-mp="2is2a8lpe3dxq">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms" className="w-full h-full object-cover opacity-25" data-id="element-6528" data-mp="2ir0onnaqz91r" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" data-id="element-6529" data-mp="2wjz00j3l5bqy"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-6530" data-mp="31jbn94ydcku2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} data-id="element-6531" data-mp="36ieg7r12r0lo">
          <Link to="/" className="inline-flex items-center gap-2 text-amber-400/70 hover:text-amber-400 text-sm tracking-wider uppercase font-light mb-12 transition-colors" data-id="element-6532" data-mp="1c6rc1dwalnsm">
            <ArrowLeft className="w-4 h-4" data-id="element-6533" data-mp="z78s0epm13f1" />
            Back to Life in the Sikh Kingdoms
          </Link>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-6534" data-mp="192iu12g0dast">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6 font-light" data-id="element-6535" data-mp="1i1w2pswb5vch">
            Presented by Akal Steel
          </p>
          <p className="text-amber-400 tracking-[0.3em] text-xs md:text-sm uppercase mb-8 font-light" data-id="element-6536" data-mp="1rul1bn6rfeqe">
            Constituency &amp; Cultural Night
          </p>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-8 tracking-tight leading-none" data-id="element-6537" data-mp="21rprrz7n1wd0">
            COMMUNITY &amp;
            <br data-id="element-6538" data-mp="2kh2vfvfnssa1" />
            <span className="text-amber-400" data-id="element-6539" data-mp="2kgji6s0yes2c">CONSTITUENCY NIGHT</span>
          </h1>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-6540" data-mp="2pdte8qium1z5"></div>
          <p className="text-lg md:text-xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-6541" data-mp="2bfv11og9kbl8">
            A Nonpartisan Cultural Celebration of Heritage, Education &amp;
            Multicultural Excellence — A Community Economic Win for Your Riding
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-white/60" data-id="element-6542" data-mp="26gs6wz1tnps1">
          <div className="text-center" data-id="element-6543" data-mp="1it0k31innuci">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-6544" data-mp="1nq0s3hz2f769">
              Heritage
            </p>
            <p className="font-serif text-xl text-white" data-id="element-6545" data-mp="2q2nhpirhio41">Education</p>
            <p className="text-xs font-light" data-id="element-6546" data-mp="2m1bmmxpudaog">Cultural Preservation</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-6547" data-mp="2habrny0a92ol"></div>
          <div className="text-center" data-id="element-6548" data-mp="2h8iiaayac4cw">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-6549" data-mp="2ccjzd2vq7ejv">
              Arts
            </p>
            <p className="font-serif text-xl text-white" data-id="element-6550" data-mp="27dgvhlrhfedh">Innovation</p>
            <p className="text-xs font-light" data-id="element-6551" data-mp="22d2vmr01baqj">Multicultural Excellence</p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" data-id="element-6552" data-mp="1ybpomdl7h1i1"></div>
          <div className="text-center" data-id="element-6553" data-mp="1ye3kuprmgjr6">
            <p className="text-sm tracking-[0.2em] uppercase mb-1 text-amber-400" data-id="element-6554" data-mp="1tdfxce2lql1p">
              Tourism
            </p>
            <p className="font-serif text-xl text-white" data-id="element-6555" data-mp="3sopc0svtuzzv">City Pride</p>
            <p className="text-xs font-light" data-id="element-6556" data-mp="3nqe2ykdcwtip">Community Economic Win</p>
          </div>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-6557" data-mp="3v9ez2kltvkw1">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent" data-id="element-6558" data-mp="8wyihu48z34u"></div>
      </motion.div>
    </section>;
}
function WhyItMattersSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-6559" data-mp="3qbdfzzoejlkk">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-6560" data-mp="11izp763oucqo"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-6561" data-mp="15jjniczzzmee">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-6562" data-mp="32l90q7f9gb5t">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-6563" data-mp="36o5bjbyk72z7">
            The Civic Case
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-6564" data-mp="2ew6boeiarg1a">
            WHY IT <span className="text-amber-400" data-id="element-6565" data-mp="2eu3d3632weky">MATTERS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-6566" data-mp="2sp5p8ayir067"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-6567" data-mp="2nwmavbs0c10c">
            For MPs, MPPs, councillors, and community leaders, this is a rare
            nonpartisan opportunity to champion heritage, education, and
            multicultural excellence in your riding.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-6568" data-mp="aolfjfofxj56">
          {[{
          icon: <BookOpen className="w-8 h-8 text-amber-400 mb-4" data-id="element-6569" data-mp="fizd9oqks2d0" />,
          title: 'Heritage & Education',
          body: 'A living classroom connecting youth, seniors, and newcomers to 200+ years of Sikh history — through taste, sight, sound, and storytelling. Preserving culture through innovation.'
        }, {
          icon: <Globe className="w-8 h-8 text-amber-400 mb-4" data-id="element-6570" data-mp="yg0klg7lqek4" />,
          title: 'Multicultural Excellence',
          body: "Showcasing South Asian culture as a cornerstone of Canada's multicultural identity. An event that brings diaspora leaders, interfaith communities, and newcomers together under one roof."
        }, {
          icon: <Award className="w-8 h-8 text-amber-400 mb-4" data-id="element-6571" data-mp="358jfvwfrbxmj" />,
          title: 'Arts Innovation',
          body: 'Oscar-winning animation, immersive dining, and interactive technology — pioneering a new form of cultural experience that positions your riding at the forefront of arts and culture in Canada.'
        }, {
          icon: <Landmark className="w-8 h-8 text-amber-400 mb-4" data-id="element-6572" data-mp="3rvq6fw10zuis" />,
          title: 'Tourism & City Pride',
          body: 'Positioning Toronto as a global destination for innovative cultural experiences. Generates local economic activity, media coverage, and community pride — a tangible win for your riding.'
        }].map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="border-2 border-amber-400/30 p-8 bg-black/40" data-id="element-6573" data-mp="envgs44tp8fx" data-mpi={i}>
              {card.icon}
              <h3 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-6574" data-mp="1ep091j483q6t">
                {card.title}
              </h3>
              <p className="text-white/70 font-light leading-relaxed" data-id="element-6575" data-mp="1jlgweb3lm0iu">
                {card.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </motion.section>;
}
function TheExperienceSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-6576" data-mp="27bl1kmwfq8by">
      <div className="container mx-auto px-4" data-id="element-6577" data-mp="2hatsf6w076u3">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-6578" data-mp="2hbln8fhs10jb">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-6579" data-mp="31sp0a6p0k57y">
            What Your Guests Will Experience
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-6580" data-mp="36r0686c6tvkw">
            THE <span className="text-amber-400" data-id="element-6581" data-mp="3bq3cfu3wm7ug">EXPERIENCE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-6582" data-mp="3fspxnc62kuio"></div>
        </motion.div>

        <div className="max-w-6xl mx-auto" data-id="element-6583" data-mp="3krkqz81ny1h1">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6584" data-mp="3kqi215nwi93r">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-6585" data-mp="1leyv0wm5rawq">
              <div className="aspect-video relative overflow-hidden" data-id="element-6586" data-mp="1947hy7k8uxj0">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rru8mxg1f864Swgj1TtDBp/Gemini_Generated_Image_xf598lxf598lxf59.png" alt="Immersive Experience" className="w-full h-full object-cover" data-id="element-6587" data-mp="194h7xv5ah4op" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-6588" data-mp="1wv3dnfrtmcvj"></div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-6" data-id="element-6589" data-mp="1nt3xepomrctn">
              <p className="text-white/80 text-lg leading-relaxed font-light" data-id="element-6590" data-mp="itx9zrej55ax">
                Life in the Sikh Kingdoms is an immersive dining and cultural
                experience that brings Maharaja Ranjit Singh's era to life
                through taste, sight, sound, and storytelling — at Toronto's
                Illuminarium.
              </p>
              <p className="text-white/70 leading-relaxed font-light" data-id="element-6591" data-mp="3r8pgm53l00bu">
                This is not theater. This is not dining. This is a portal to
                1825 Lahore — a nonpartisan cultural institution celebrating
                heritage, education, multicultural excellence, arts innovation,
                and city pride.
              </p>

              <div className="border-l-2 border-amber-400/30 pl-6 space-y-4" data-id="element-6592" data-mp="38awayv1kpcar">
                {['5–7 courses synchronized with immersive projections', '360° visual storytelling across walls, floor, and tables', 'Royal Punjabi cuisine from world-renowned chefs', '90 minutes of complete cultural immersion', 'Interactive technology — voice, motion, and scent'].map((item, i) => <div key={i} className="flex items-start" data-id="element-6593" data-mp="2xpj5rc1548iw" data-mpi={i}>
                    <span className="text-amber-400 mr-3 mt-1" data-id="element-6594" data-mp="2xs5f9h7lcy3r">—</span>
                    <span className="text-white/70 font-light" data-id="element-6595" data-mp="3cm0f5xprrd2t">{item}</span>
                  </div>)}
              </div>

              <div className="border border-amber-400/30 p-6 bg-black/40" data-id="element-6596" data-mp="37me1xo9xxwu0">
                <div className="grid grid-cols-3 gap-4 text-center" data-id="element-6597" data-mp="3letyc68c6wly">
                  <div data-id="element-6598" data-mp="3hf33nrfovwc5">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-6599" data-mp="3hetm8s8pmxi2">
                      Venue
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-6600" data-mp="3qeyh62wpw3fc">
                      Illuminarium Toronto
                    </p>
                  </div>
                  <div data-id="element-6601" data-mp="eb6mb04usqpv">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-6602" data-mp="e9m1i28ccm57">
                      Date
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-6603" data-mp="n3gy2lved498">Summer 2026</p>
                  </div>
                  <div data-id="element-6604" data-mp="s1s74udvbaqe">
                    <p className="text-amber-400 text-xs tracking-wider uppercase mb-1" data-id="element-6605" data-mp="s2bskl2q8h96">
                      Capacity
                    </p>
                    <p className="text-white font-light text-sm" data-id="element-6606" data-mp="3vjadsyhwmbp8">
                      Up to 120 Guests
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-2 border-amber-400/40 p-6 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-6607" data-mp="9cc6m726ni9z">
                <p className="text-white/70 font-light text-sm leading-relaxed" data-id="element-6608" data-mp="1fsxmz9jt630p">
                  <span className="text-amber-400 font-medium" data-id="element-6609" data-mp="1krimf6r8kio3">
                    ROM Legacy:{' '}
                  </span>
                  This experience honors the groundbreaking "Art of the Sikh
                  Kingdoms" exhibition at the Royal Ontario Museum —{' '}
                  <strong className="text-white" data-id="element-6610" data-mp="30cjk1usgqh78">
                    the second most popular exhibition in ROM history
                  </strong>
                  .
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
}
function InvolvementOptionsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-6611" data-mp="27nccy7ey0jad">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black z-0" data-id="element-6612" data-mp="5twlj8b170ec"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-6613" data-mp="20awioilaxqr0">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-6614" data-mp="208jtplh4mg4g">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-6615" data-mp="2j0uun9s803zx">
            Simple Menu of Options
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-6616" data-mp="2nzpco9id5oiz">
            WAYS TO <span className="text-amber-400" data-id="element-6617" data-mp="29zo7wiyz9wy8">GET INVOLVED</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-6618" data-mp="2e19uiw1bdplm"></div>
          <p className="text-white/70 font-light max-w-2xl mx-auto" data-id="element-6619" data-mp="ylar1y2n6hrp">
            Whether you're an MP, MPP, city councillor, or community leader —
            choose the level of involvement that fits your schedule and
            priorities.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-6620" data-mp="v5g71m3ysbsr">
          {/* Option A */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0
        }} className="relative" data-id="element-6621" data-mp="q6mrlo54aapy">
            <div className="absolute top-0 left-0 right-0 flex justify-center z-30 transform -translate-y-1/2" data-id="element-6622" data-mp="7by2maxrgawf">
              <div className="bg-amber-400 text-black font-bold py-1.5 px-5 flex items-center gap-2" data-id="element-6623" data-mp="hc8glxrmdmcn">
                <Star className="w-3 h-3" fill="currentColor" data-id="element-6624" data-mp="3prifyy44kdgq" />
                <span className="text-xs uppercase tracking-wider" data-id="element-6625" data-mp="3ppxgqv6v86cj">
                  Recommended
                </span>
              </div>
            </div>
            <div className="border-2 border-amber-400 bg-black/80 p-8 pt-10 h-full" data-id="element-6626" data-mp="2za5ox3q712qi">
              <div className="flex items-center gap-3 mb-4" data-id="element-6627" data-mp="347xf9tb6wgsl">
                <span className="font-serif text-3xl text-amber-400/40" data-id="element-6628" data-mp="34ajmfru64uaa">A</span>
                <h3 className="font-serif text-2xl text-white" data-id="element-6629" data-mp="395yz4ggfwk54">
                  Patron of the Night
                </h3>
              </div>
              <p className="text-amber-400/70 text-xs tracking-wider uppercase mb-4 font-light" data-id="element-6630" data-mp="3i8hwwm5dc6ki">
                Constituency Night Host
              </p>
              <ul className="space-y-3" data-id="element-6631" data-mp="3n5qhsuhwiopg">
                {['Host the Constituency Night as Guest of Honour', 'Short welcome remarks (5–7 minutes)', 'Photo moment + community recognition segment', 'Press photo call with community leaders'].map((item, i) => <li key={i} className="flex items-start text-white/70 text-sm font-light" data-id="element-6632" data-mp="9rvi7uq59dwx" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-amber-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-6633" data-mp="1ubqx3g9owsy2" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Option B */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-6634" data-mp="1gb7pga94zowf">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full" data-id="element-6635" data-mp="246aeojburudf">
              <div className="flex items-center gap-3 mb-4" data-id="element-6636" data-mp="1z9aakdykd1oy">
                <span className="font-serif text-3xl text-amber-400/40" data-id="element-6637" data-mp="2wpzjsspuf68d">B</span>
                <h3 className="font-serif text-2xl text-white" data-id="element-6638" data-mp="2rxo86slqpvzz">
                  Cultural Roundtable
                </h3>
              </div>
              <p className="text-amber-400/70 text-xs tracking-wider uppercase mb-4 font-light" data-id="element-6639" data-mp="39n10ik3w1fob">
                Community Leader Convening
              </p>
              <ul className="space-y-3" data-id="element-6640" data-mp="2zmqm4w64a27k">
                {['Private preview for community leaders & sponsors', 'Convene diaspora, cultural orgs, and business leaders', 'Sponsorship ladder pitch opportunity'].map((item, i) => <li key={i} className="flex items-start text-white/70 text-sm font-light" data-id="element-6641" data-mp="3ncba5th4npnp" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-amber-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-6642" data-mp="3ik1legrr0vn0" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Option C */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-6643" data-mp="a62rdkoc7kc5">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full" data-id="element-6644" data-mp="weqboqg2i8ip">
              <div className="flex items-center gap-3 mb-4" data-id="element-6645" data-mp="wcnd3i0un72d">
                <span className="font-serif text-3xl text-amber-400/40" data-id="element-6646" data-mp="11crwpgx20hwt">C</span>
                <h3 className="font-serif text-2xl text-white" data-id="element-6647" data-mp="15ewoea3xz4gt">
                  Youth Heritage Night
                </h3>
              </div>
              <p className="text-amber-400/70 text-xs tracking-wider uppercase mb-4 font-light" data-id="element-6648" data-mp="1a6wr2abecbh3">
                Education &amp; Legacy
              </p>
              <ul className="space-y-3" data-id="element-6649" data-mp="1k4ucyr5s9w6j">
                {['Student tickets + mentorship tie-in', 'Educator guide + talkback session', 'Highlight youth & heritage mandate'].map((item, i) => <li key={i} className="flex items-start text-white/70 text-sm font-light" data-id="element-6650" data-mp="zcx6qqf5ves0" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-amber-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-6651" data-mp="195uw9gikm404" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Option D */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-6652" data-mp="1i7kk6cd8ukt5">
            <div className="border-2 border-amber-400/30 bg-black/80 p-8 h-full" data-id="element-6653" data-mp="3tvtxz890vgua">
              <div className="flex items-center gap-3 mb-4" data-id="element-6654" data-mp="3oxiqh4679if8">
                <span className="font-serif text-3xl text-amber-400/40" data-id="element-6655" data-mp="24ef0ybpnr4vx">D</span>
                <h3 className="font-serif text-2xl text-white" data-id="element-6656" data-mp="24gj24lw69psi">
                  Sponsor Drive
                </h3>
              </div>
              <p className="text-amber-400/70 text-xs tracking-wider uppercase mb-4 font-light" data-id="element-6657" data-mp="1up54ykrp122j">
                Business Community Activation
              </p>
              <ul className="space-y-3" data-id="element-6658" data-mp="1zl3pfx9whzxo">
                {['Introduce 5–10 local sponsor prospects', 'Warm intros to local businesses in your riding', 'We close the deals — minimal time required'].map((item, i) => <li key={i} className="flex items-start text-white/70 text-sm font-light" data-id="element-6659" data-mp="1brlrn4y7cxab" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-amber-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-6660" data-mp="364k1xojwjtxn" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>;
}
function ConstituencyNightSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-6661" data-mp="s1htx67gie6u">
      <div className="container mx-auto px-4" data-id="element-6662" data-mp="n988o3hae2aw">
        <div className="max-w-5xl mx-auto" data-id="element-6663" data-mp="iboluf6iwh7c">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-6664" data-mp="ichvpp0s3mtp">
            <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-6665" data-mp="2fy7iklxrx01f">
              The Vision
            </p>
            <h2 className="font-serif text-5xl md:text-6xl text-white mb-8" data-id="element-6666" data-mp="2kwsmavc8i1um">
              CONSTITUENCY NIGHT{' '}
              <span className="text-amber-400" data-id="element-6667" data-mp="2pvc4qlrmcvi8">DONE RIGHT</span>
            </h2>
            <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-6668" data-mp="2tyic5wqgwsqa"></div>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-6669" data-mp="1xacbfkwo2kha">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-6670" data-mp="228xcfmjqt86s">
              <div className="border-2 border-amber-400/40 p-8 md:p-10 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-6671" data-mp="1ijmue1wiyb5i">
                <h3 className="font-serif text-2xl text-amber-400 mb-6" data-id="element-6672" data-mp="2ltqyx03dpnj4">
                  What It Looks Like
                </h3>
                <div className="space-y-5" data-id="element-6673" data-mp="2gvfpurkwrh1y">
                  {[{
                  icon: <Crown className="w-4 h-4 text-amber-400" data-id="element-6674" data-mp="2vjsndszn97yk" />,
                  title: 'Guest of Honour Welcome',
                  sub: '5–7 minute opening remarks from the elected official or community leader'
                }, {
                  icon: <Star className="w-4 h-4 text-amber-400" data-id="element-6675" data-mp="1xy53g7kdki3x" />,
                  title: 'Recognition of Community Builders',
                  sub: 'Acknowledge local leaders, volunteers, and cultural champions'
                }, {
                  icon: <Heart className="w-4 h-4 text-amber-400" data-id="element-6676" data-mp="3nb8i6abcu0zv" />,
                  title: 'Optional Nonprofit Tie-In',
                  sub: 'Keeps it civic, not political — fundraising for ROM Sikh gallery'
                }, {
                  icon: <Users className="w-4 h-4 text-amber-400" data-id="element-6677" data-mp="3qw1wdcdmll0f" />,
                  title: 'Group Tickets for Local Orgs',
                  sub: 'Youth seats sponsored by a local business — full room guaranteed'
                }, {
                  icon: <Camera className="w-4 h-4 text-amber-400" data-id="element-6678" data-mp="3luushoelt5z1" />,
                  title: 'Press Photo Call',
                  sub: 'Professional photography, ethnic media coverage, community papers'
                }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-6679" data-mp="3nycgc6zrnkt" data-mpi={i}>
                      <div className="w-8 h-8 flex items-center justify-center border border-amber-400/30 flex-shrink-0 mt-0.5" data-id="element-6680" data-mp="8nsxhz435ixy">
                        {item.icon}
                      </div>
                      <div data-id="element-6681" data-mp="1143q47fp757q">
                        <p className="text-white font-light text-sm mb-1" data-id="element-6682" data-mp="115f4f16rrvd3">
                          {item.title}
                        </p>
                        <p className="text-white/50 text-xs font-light" data-id="element-6683" data-mp="2x9mmcnnaic2i">
                          {item.sub}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-6" data-id="element-6684" data-mp="2jhoj2tg9fae9">
              <div className="border border-amber-400/30 p-6 bg-black/40" data-id="element-6685" data-mp="326d0h5fjaxla">
                <h4 className="font-serif text-xl text-amber-400 mb-4" data-id="element-6686" data-mp="1vrc1srz4k1b0">
                  The Result
                </h4>
                <div className="space-y-3" data-id="element-6687" data-mp="1qq4sgohc2u28">
                  {['Full room with engaged community members', 'Strong press photos for all parties', 'Goodwill across diaspora, cultural, and civic communities', 'Sponsor confidence from dignitary presence', 'Media coverage in ethnic and community press'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-6688" data-mp="1ze91l1gfmxwy" data-mpi={i}>
                      <CheckCircle className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-6689" data-mp="1zgd69lm5o0ya" />
                      <span className="text-white/70 text-sm font-light" data-id="element-6690" data-mp="24b926wuij8go">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>

              <div className="border-2 border-amber-400/40 p-6 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-6691" data-mp="2e8x4c7ug7i8v">
                <p className="text-amber-400 text-xs tracking-wider uppercase mb-3 font-light" data-id="element-6692" data-mp="jwyvi701wodi">
                  Who Gets Invited
                </p>
                <div className="space-y-2 text-white/60 text-sm font-light" data-id="element-6693" data-mp="2qb9s0pj1r0a2">
                  <p data-id="element-6694" data-mp="2v4kxonc4hb0e">— Diaspora leaders &amp; cultural organizations</p>
                  <p data-id="element-6695" data-mp="2hcegcxx8gxzd">— School boards &amp; newcomer services</p>
                  <p data-id="element-6696" data-mp="2ha1sy58phvex">— Business improvement areas (BIAs)</p>
                  <p data-id="element-6697" data-mp="2mcamp3tel1i3">— Tourism groups &amp; arts councils</p>
                  <p data-id="element-6698" data-mp="3a0tu7h4mpa94">— Local sponsors (banks, telcos, hotels)</p>
                  <p data-id="element-6699" data-mp="3a1lg208fbtm7">— Consular reps &amp; interfaith leaders</p>
                </div>
              </div>

              <div className="border-2 border-amber-400/40 p-6 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-6700" data-mp="3e1m3ubhexh5x">
                <Heart className="w-6 h-6 text-amber-400 mb-3" data-id="element-6701" data-mp="30509hagraag9" />
                <p className="text-amber-400 italic font-light text-sm leading-relaxed" data-id="element-6702" data-mp="3505v0868xn3t">
                  "A portion of all proceeds goes directly to the Sikh Art and
                  Culture Gallery at the Royal Ontario Museum, preserving Sikh
                  heritage for future generations."
                </p>
                <p className="text-white/40 text-xs font-light mt-3 tracking-wider uppercase" data-id="element-6703" data-mp="1m55kigyg7v1j">
                  Every ticket funds cultural storytelling + community uplift
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
}
function ConstituencyCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section ref={sectionRef} style={{
    opacity
  }} className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-6704" data-mp="1c6g0oimzs0in">
      <div className="container mx-auto px-4" data-id="element-6705" data-mp="joamquw74k49">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-6706" data-mp="jmziyv2r3cd5">
          <Landmark className="w-10 h-10 text-amber-400 mx-auto mb-6" data-id="element-6707" data-mp="2oha421b4azkj" />
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6" data-id="element-6708" data-mp="2tgn11evpdn0u">
            Let's Build Something{' '}
            <span className="text-amber-400" data-id="element-6709" data-mp="1vteb97oo5rt1">Meaningful Together</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-6710" data-mp="20ry0bgyk7jpm"></div>
          <p className="text-xl text-white/70 font-light mb-4 leading-relaxed" data-id="element-6711" data-mp="20u1zxmpfdwk3">
            We welcome the opportunity to discuss how this cultural experience
            can serve your constituency and community.
          </p>
          <p className="text-white/50 font-light mb-10 leading-relaxed" data-id="element-6712" data-mp="3h67kdyvrqman">
            This is a nonpartisan cultural institution open to MPs, MPPs, city
            councillors, and community leaders of all backgrounds. Our goal is
            to celebrate heritage, support education, and create a community
            economic win for your riding — together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-6713" data-mp="15kypsa9vjzr5">
            <motion.a href="https://wa.me/14169998778?text=I%20am%20interested%20in%20discussing%20a%20constituency%20night%20for%20Life%20in%20the%20Sikh%20Kingdoms" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-amber-400 hover:bg-amber-500 text-black px-8 py-4 font-medium tracking-wider uppercase text-sm transition-colors duration-300" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-6714" data-mp="10qkqhws3d8h7">
              <MessageCircle className="w-5 h-5" data-id="element-6715" data-mp="2c6j3ucuaygo8" />
              Start the Conversation
            </motion.a>
            <Link to="/" className="inline-flex items-center justify-center gap-2 border-2 border-amber-400/50 hover:border-amber-400 text-white hover:text-amber-400 px-8 py-4 font-light tracking-wider uppercase text-sm transition-all duration-300" data-id="element-6716" data-mp="2764u8qd1yyo3">
              <ArrowLeft className="w-4 h-4" data-id="element-6717" data-mp="uyq6nkn52sv0" />
              Back to Main Site
            </Link>
          </div>
          <p className="text-white/40 text-sm font-light mt-6" data-id="element-6718" data-mp="zxjlbge5wpwr">
            Our team will respond within 24 hours to discuss partnership
            opportunities.
          </p>
        </motion.div>
      </div>
    </motion.section>;
}